export const colWidths = [
    0,
    0,
    25,
    40,
    0,
    25,
    0,
    40, 
    20,  
];
